module.exports = __webpack_public_path__ + "MamaQueenGeek.jpg?690ffd2627e24d24a363033960751cc6";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MamaQueenGeek.jpg
// module id = 525
// module chunks = 0